import { Component, AfterViewChecked, Output, Input, EventEmitter, ViewChild, ElementRef, OnDestroy, OnInit, AfterViewInit, OnChanges, SimpleChanges  } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AdvancedHeatmapLayer } from 'leaflet-advanced-heatmap'

import * as L from 'leaflet';
import * as Highcharts from 'highcharts';
import "leaflet-draw";
import 'esri-leaflet';
import 'leaflet.markercluster';
//import { featureLayer as efl } from 'esri-leaflet-cluster';
import * as EL from 'esri-leaflet';
import * as E from 'esri-leaflet-cluster';
import 'leaflet-switch-basemap';
import * as KML from 'src/app/components/map/leaflet.kml';
import 'esri-leaflet-renderers';
import {decode} from "@msgpack/msgpack";

import { Camera, SiteTwin } from 'src/api/models';
import { IconService } from 'src/service/icon.service';
import { ScriptService } from 'src/service/script.service';

import { Incident,IncidentsData,Warning,WarningsData,GeoJsonFeature,GeoJsonFeatureCollection } from 'src/app/models/wa-emergency-json';
import { UserService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';

//import { get } from 'scriptjs';
//import * as wind from 'leaflet-velocity';

//declare function windyInit(options, callback);

const iconRetinaUrl = 'assets/pins/marker-icon-2x-red.png';
const iconUrl = 'assets/pins/marker-icon-2x-red.png';
const shadowUrl = 'assets/marker-shadow.png';
const iconDefault = L.icon({
  iconRetinaUrl,
  iconUrl,
  shadowUrl,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});

export class Location{
  public identifier: any;
  public latitude: number;
  public longitude: number;
}

export interface ElevationProfilePoint {
  distance: number;  // Distance in km
  elevation: number; // Elevation in meters
  lat: number;
  lng: number;
  index?: number;
  visible?: boolean; // Line-of-sight visibility from observer
}

export interface ElevationProfile {
  points: ElevationProfilePoint[];
  bearing: number;
  maxDistance: number;
  maxElevation: number;
}

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
// https://www.digitalocean.com/community/tutorials/angular-angular-and-leaflet
export class MapComponent implements AfterViewChecked, OnDestroy, OnInit, AfterViewInit, OnChanges  {
  public map: L.map;

  @ViewChild('map', {static: false}) protected mapDivRef: ElementRef;
  protected mapDiv: HTMLDivElement;

  @Output() leftClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() mapInitComplete: EventEmitter<L.map> = new EventEmitter<L.map>();
  @Input() mapheight: string;
  @Input() mapType: string;
  @Input() location: Location;
  @Input() elevationProfile?: ElevationProfile;
  @Input() showElevationChart: boolean = false;
  @Input() observerHeight: number = 20.0;

  @ViewChild('elevationChart', {static: false}) protected elevationChartRef: ElementRef;

  // Highcharts properties
  public Highcharts = Highcharts;
  public chartOptions: Highcharts.Options;
  public chart: Highcharts.Chart;
  public elevationHoverMarker: L.circleMarker;
  public elevationProfileLine: L.Polyline;
  public elevationProfileHitLine: L.Polyline; // Invisible wider line for easier hover detection
  public elevationProfileGroup: L.FeatureGroup; // Group containing all elevation profile segments
  private losLine: any; // Highcharts SVG renderer path for line-of-sight line
  private losMarker: any; // Highcharts SVG renderer path for intersection marker
  private losAngleLabel: any; // Highcharts SVG renderer text for tilt angle display
  private mapLosMarker: L.Marker; // Leaflet marker for intersection on map
  private observerElevation: number; // Cached observer elevation for updateLosLine

  public pins: any;
  public defaultIcon: L.icon;// = icons.blue;
  public selectedIcon: L.icon;// = icons.blueSelected;

  tiles: L.tileLayer;
  googleTerrain: L.tileLayer;
  googleStreets: L.tileLayer;
  googleSat: L.tileLayer;
  lastLayer: L.tileLayer;

  shape: L.FeatureGroup;

  private measurementLeaflet: any;
  private measurementLayers: L.FeatureGroup;
  private measurementControl: L.Control;
  private readonly measurementCreatedHandler = (event: any) => {
    const layer = event.layer;
    this.measurementLayers.addLayer(layer);
    this.updateMeasurementLabel(layer);
  };
  private readonly measurementEditedHandler = (event: any) => {
    event.layers.eachLayer((layer: L.Layer) => this.updateMeasurementLabel(layer));
  };

  datalayers: any = {};
  trackers: any = {};
  trackerPoints: any = {};
  heatmaps: any = {};
  staticsites: any = {};
  geojsonitems: any = {};
  groups: any[] = [];

  customerMapSettings: any = {
      center: [-42.026167,146.708500],
      zoom: 8,
      maxZoom: 20,
      zoomControl: false
    };

  constructor(public icons: IconService, public http: HttpClient, public script: ScriptService, private configService: ApplicationConfigService) {
    icons.getPins(() => { 
      this.defaultIcon = icons.pins.blueSelected;
      this.selectedIcon = icons.pins.blue;

      L.Icon.Default.prototype.options.iconUrl = this.defaultIcon.iconUrl;
      L.Icon.Default.prototype.options.iconRetinaUrl = this.defaultIcon.iconRetinaUrl;
      L.Icon.Default.prototype.options.shadowUrl = this.defaultIcon.shadowUrl;
      L.Icon.Default.prototype.options.shadowRetinaUrl = this.defaultIcon.shadowRetinaUrl;
    });


  }

  private init: boolean;
  public initMap(): void {
    if (this.init){
      return;
    }


    if(this.configService.customer)
    {
      this.customerMapSettings = {
        center: [this.configService.customer.centreMapLatitude,this.configService.customer.centreMapLongitude],
        zoom: 8,
        maxZoom: 20,
        zoomControl: false
      };
    }
    else{
      this.customerMapSettings = {
        center: [-42.026167,146.708500],
        zoom: 8,
        maxZoom: 20,
        zoomControl: false
      };
    }



    
    this.init = true;
   
    
    if (this.map == null) {

      this.map = L.map(this.mapDivRef.nativeElement, this.customerMapSettings);

      L.control.zoom({
        position: 'bottomright'
      }).addTo(this.map);

      this.mapDiv = this.mapDivRef.nativeElement;
      this.mapDiv.style.height = this.mapheight;
    
      this.tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      });
      this.googleTerrain = L.tileLayer('https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
      });
      this.googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
      });
      this.googleSat = L.tileLayer('https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
      });
      this.setLayer(this.mapType);
      
      new L.basemapsSwitcher([
        {
          layer: this.tiles,
          icon: './assets/maps/osm.PNG',
          name: 'Open Street Map'
        },
        {
          layer: this.googleTerrain,
          icon: './assets/maps/googleTerrain.PNG',
          name: 'Google Terrain'
        },
        {
          layer: this.googleStreets,
          icon: './assets/maps/googleStreets.PNG',
          name: 'Google Streets'
        },
        {
          layer: this.googleSat,
          icon: './assets/maps/googleSatellite.PNG',
          name: 'Google Satellite'
        }
      ], { position: 'bottomleft' }).addTo(this.map);
      

      this.initMeasurementTools();

      if (this.mapInitComplete){
        this.mapInitComplete.emit(this.map);
      }
    }
  } 

  private initMeasurementTools(): void {
    this.measurementLeaflet = (window as any).L;
    const drawControl = this.measurementLeaflet?.Control?.Draw;
    const geometryUtil = this.measurementLeaflet?.GeometryUtil;
    if (!drawControl || !geometryUtil) {
      console.error('Leaflet Draw measurement tools are unavailable');
      return;
    }

    this.installAreaFormatter(geometryUtil);
    this.measurementLayers = this.measurementLeaflet.featureGroup().addTo(this.map);
    this.measurementControl = new drawControl({
      position: 'topright',
      draw: {
        polygon: {
          allowIntersection: false,
          metric: true,
          showArea: true,
          shapeOptions: {
            color: '#ff0080',
            fillOpacity: 0.12
          }
        },
        polyline: {
          metric: true,
          showLength: true,
          shapeOptions: {
            color: '#ff0080',
            weight: 3
          }
        },
        rectangle: false,
        circle: false,
        marker: false,
        circlemarker: false
      },
      edit: {
        featureGroup: this.measurementLayers,
        remove: true
      }
    });

    this.map.addControl(this.measurementControl);
    this.map.on(this.measurementLeaflet.Draw.Event.CREATED, this.measurementCreatedHandler);
    this.map.on(this.measurementLeaflet.Draw.Event.EDITED, this.measurementEditedHandler);
  }

  private installAreaFormatter(geometryUtil: any): void {
    geometryUtil.readableArea = function(area: number, isMetric: boolean, precision: any = {}): string {
      const decimals = {
        km: precision.km ?? 2,
        ha: precision.ha ?? 2,
        m: precision.m ?? 0,
        mi: precision.mi ?? 2,
        ac: precision.ac ?? 2,
        yd: precision.yd ?? 0
      };

      if (isMetric) {
        if (area >= 1000000) {
          return geometryUtil.formattedNumber(area / 1000000, decimals.km) + ' km²';
        }
        if (area >= 10000) {
          return geometryUtil.formattedNumber(area / 10000, decimals.ha) + ' ha';
        }
        return geometryUtil.formattedNumber(area, decimals.m) + ' m²';
      }

      const squareYards = area / 0.836127;
      if (squareYards >= 3097600) {
        return geometryUtil.formattedNumber(squareYards / 3097600, decimals.mi) + ' mi²';
      }
      if (squareYards >= 4840) {
        return geometryUtil.formattedNumber(squareYards / 4840, decimals.ac) + ' acres';
      }
      return geometryUtil.formattedNumber(squareYards, decimals.yd) + ' yd²';
    };
  }

  private updateMeasurementLabel(layer: L.Layer): void {
    const geometryUtil = this.measurementLeaflet.GeometryUtil;
    let label: string;

    if (layer instanceof this.measurementLeaflet.Polygon) {
      const rings = layer.getLatLngs() as L.LatLng[][];
      const area = geometryUtil.geodesicArea(rings[0] || []);
      label = geometryUtil.readableArea(area, true);
    } else if (layer instanceof this.measurementLeaflet.Polyline) {
      const points = layer.getLatLngs() as L.LatLng[];
      const distance = points.slice(1).reduce(
        (total, point, index) => total + points[index].distanceTo(point),
        0
      );
      const bearing = this.calculateInitialBearing(points[0], points[points.length - 1]);
      label = geometryUtil.readableDistance(distance, true) + ' · ' + bearing.toFixed(1) + '°';
    } else {
      return;
    }

    const measuredLayer = layer as L.Polyline;
    measuredLayer.unbindTooltip();
    measuredLayer.bindTooltip(label, {
      permanent: true,
      direction: 'center',
      className: 'map-measurement-label'
    }).openTooltip();
  }

  private calculateInitialBearing(start: L.LatLng, end: L.LatLng): number {
    const degreesToRadians = Math.PI / 180;
    const radiansToDegrees = 180 / Math.PI;
    const startLatitude = start.lat * degreesToRadians;
    const endLatitude = end.lat * degreesToRadians;
    const longitudeDelta = (end.lng - start.lng) * degreesToRadians;
    const y = Math.sin(longitudeDelta) * Math.cos(endLatitude);
    const x = Math.cos(startLatitude) * Math.sin(endLatitude) -
      Math.sin(startLatitude) * Math.cos(endLatitude) * Math.cos(longitudeDelta);

    return (Math.atan2(y, x) * radiansToDegrees + 360) % 360;
  }

  private cleanupMeasurementTools(): void {
    if (!this.map) {
      return;
    }

    const drawEvents = this.measurementLeaflet?.Draw?.Event;
    if (drawEvents) {
      this.map.off(drawEvents.CREATED, this.measurementCreatedHandler);
      this.map.off(drawEvents.EDITED, this.measurementEditedHandler);
    }
    if (this.measurementControl) {
      this.map.removeControl(this.measurementControl);
      this.measurementControl = null;
    }
    if (this.measurementLayers) {
      this.measurementLayers.clearLayers();
      this.map.removeLayer(this.measurementLayers);
      this.measurementLayers = null;
    }
    this.measurementLeaflet = null;
  }


  public setLayer(layerName){
    this.mapType = layerName;
    if (this.mapType == null ||  this.mapType == "googleTerrain"){
      this.changeLayer(this.googleTerrain);
    } else if (this.mapType == "googleStreets"){
      this.changeLayer(this.googleStreets);
    } else if (this.mapType == "googleSat"){
      this.changeLayer(this.googleSat);
    } else {
      this.changeLayer(this.tiles);
    }
  }

  private changeLayer(layer: L.tileLayer){
    if (this.lastLayer){
      this.map.removeLayer(this.lastLayer);
    }
    layer.addTo(this.map);
    this.lastLayer = layer;
  }

  ngOnInit(): void {
  
  }

  ngAfterViewInit(): void {
    console.log("Map Init");
    this.initMap();
    // Initialize elevation chart if profile data is provided
    if (this.showElevationChart && this.elevationProfile) {
      setTimeout(() => this.initElevationChart(), 100);
    }
  }

  ngAfterViewChecked(): void {
    //console.log("Map Init");
    //this.initMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reinitialize chart when elevation profile changes
    if (changes['elevationProfile'] && !changes['elevationProfile'].firstChange) {
      if (this.showElevationChart && this.elevationProfile) {
        // Clean up existing markers before reinitializing
        this.cleanupElevationChart();
        setTimeout(() => this.initElevationChart(), 100);
      } else {
        this.cleanupElevationChart();
      }
    }
  }

  private cleanupElevationChart(): void {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
    if (this.elevationProfileLine) {
      this.map.removeLayer(this.elevationProfileLine);
      this.elevationProfileLine = null;
    }
    if (this.elevationProfileHitLine) {
      this.map.removeLayer(this.elevationProfileHitLine);
      this.elevationProfileHitLine = null;
    }
    if (this.elevationProfileGroup) {
      this.map.removeLayer(this.elevationProfileGroup);
      this.elevationProfileGroup = null;
    }
    if (this.mapLosMarker) {
      this.map.removeLayer(this.mapLosMarker);
      this.mapLosMarker = null;
    }
  }

  ngOnDestroy(): void {
    console.log("Map Destroy");
      this.cleanupElevationChart();
      this.cleanupMeasurementTools();
      if (this.map){
        this.map.off();
        this.map.remove();
        this.map = null;
      }
  }

  public redraw(){
    setTimeout(() => {
      this.map.invalidateSize();
      if (this.chart) {
        this.chart.reflow();
      }
    }, 50);
  }

  /**
   * Calculate line-of-sight visibility for elevation profile points
   * Determines which points are visible from the observer location considering terrain occlusion and earth curvature
   */
  private calculateLineOfSight(points: ElevationProfilePoint[]): void {
    if (!points || points.length === 0) {
      return;
    }

    const observerElev = points[0].elevation + this.observerHeight;
    const earthRadiusMeters = 6371000;
    let maxSlope = -Infinity;

    // Store observer elevation for use in updateLosLine
    this.observerElevation = observerElev;

    for (let i = 0; i < points.length; i++) {
      if (i === 0) {
        points[i].visible = true; // Observer origin is always visible
        continue;
      }
      
      const distMeters = points[i].distance * 1000;
      
      // Geodesic adjustment: Apparent elevation drops over large distances 
      // due to the curvature of the earth (approx 70m drop over 30km)
      const curvatureDropMeters = (distMeters * distMeters) / (2 * earthRadiusMeters);
      const apparentElev = points[i].elevation - curvatureDropMeters;
      
      // Calculate viewing angle slope
      const slope = (apparentElev - observerElev) / distMeters;
      
      if (slope >= maxSlope) {
        points[i].visible = true;
        maxSlope = slope; // Highest point sets the new occlusion boundary
      } else {
        points[i].visible = false; // Obscured by terrain
      }
    }
  }

  private initElevationChart(): void {
    if (!this.elevationProfile || !this.elevationChartRef) {
      return;
    }

    // Clean up any existing elevation chart components
    this.cleanupElevationChart();
    
    // Calculate line-of-sight visibility for all points
    this.calculateLineOfSight(this.elevationProfile.points);
    
    // Draw elevation profile path line on map
    this.drawElevationProfileLine();

    // Prepare chart data
    const chartData: [number, number][] = this.elevationProfile.points.map(pt => [pt.distance, pt.elevation]);

    // Build Highcharts zones based on visibility transitions
    const zones: any[] = [];
    const colorVis = '#22c55e'; // Green for visible
    const fillVis = { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, 'rgba(34, 197, 94, 0.4)'], [1, 'rgba(34, 197, 94, 0.05)']] };
    const colorHid = '#9ca3af'; // Gray for obscured
    const fillHid = { linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 }, stops: [[0, 'rgba(156, 163, 175, 0.4)'], [1, 'rgba(156, 163, 175, 0.05)']] };

    let currentVis = this.elevationProfile.points[0].visible ?? true;
    for (let i = 1; i < this.elevationProfile.points.length; i++) {
      const pointVis = this.elevationProfile.points[i].visible ?? true;
      if (pointVis !== currentVis) {
        zones.push({
          value: this.elevationProfile.points[i].distance,
          color: currentVis ? colorVis : colorHid,
          fillColor: currentVis ? fillVis : fillHid
        });
        currentVis = pointVis;
      }
    }
    // Push final trailing zone
    zones.push({
      color: currentVis ? colorVis : colorHid,
      fillColor: currentVis ? fillVis : fillHid
    });

    // Initialize hover marker on map (invisible by default)
    if (!this.elevationHoverMarker && this.map) {
      this.elevationHoverMarker = L.circleMarker([0, 0], {
        radius: 6,
        fillColor: '#ef4444',
        color: '#ffffff',
        weight: 2,
        opacity: 0,
        fillOpacity: 0,
        interactive: false
      }).addTo(this.map);
    }

    // Configure Highcharts options
    this.chartOptions = {
      chart: {
        type: 'area',
        height: 250,
        width: null, // Auto-fit to container width
        backgroundColor: 'transparent',
        margin: [15, 10, 55, 85], // Top, Right, Bottom, Left
        style: { fontFamily: 'inherit' },
        animation: false,
        reflow: true
      },
      title: { text: null },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        title: { text: 'Distance (km)' },
        crosshair: {
          width: 1,
          color: '#9ca3af',
          dashStyle: 'ShortDot'
        },
        labels: { format: '{value} km' }
      },
      yAxis: {
        title: { text: 'Elevation (m)' },
        labels: { format: '{value} m' }
      },
      tooltip: {
        formatter: function () {
          const pt = this.series.chart.userOptions.elevationProfile?.points[this.point.index];
          const visText = pt?.visible ? '<span style="color:#22c55e; font-weight:bold;">Visible</span>' : '<span style="color:#9ca3af; font-weight:bold;">Obscured</span>';
          return `<b>Distance:</b> ${this.x} km<br/><b>Elevation:</b> ${this.y} m<br/><b>Line of Sight:</b> ${visText}`;
        },
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderWidth: 1,
        shadow: true
      },
      plotOptions: {
        area: {
          marker: {
            radius: 2,
            states: {
              hover: { 
                radius: 5, 
                fillColor: '#ef4444', 
                lineColor: '#fff', 
                lineWidth: 2 
              }
            }
          },
          lineWidth: 2
        },
        series: {
          point: {
            events: {
              mouseOver: (event) => {
                const pointIndex = (event.target as any).index;
                if (pointIndex !== undefined && this.elevationProfile) {
                  const pt = this.elevationProfile.points[pointIndex];
                  if (pt && this.elevationHoverMarker) {
                    this.elevationHoverMarker.setLatLng([pt.lat, pt.lng]);
                    this.elevationHoverMarker.setStyle({ opacity: 1, fillOpacity: 1 });
                  }
                  // Update line-of-sight visualization
                  this.updateLosLine(pointIndex);
                }
              }
            }
          },
          events: {
            mouseOut: () => {
              if (this.elevationHoverMarker) {
                this.elevationHoverMarker.setStyle({ opacity: 0, fillOpacity: 0 });
              }
              // Hide line-of-sight visualization
              this.updateLosLine(null);
            }
          }
        }
      },
      series: [{
        type: 'area',
        name: 'Elevation',
        data: chartData,
        zoneAxis: 'x',
        zones: zones
      }],
      elevationProfile: this.elevationProfile // Store reference for tooltip formatter
    } as any;

    // Create the chart
    this.chart = Highcharts.chart(this.elevationChartRef.nativeElement, this.chartOptions);

    // Initialize SVG line-of-sight line (orange dashed)
    this.losLine = this.chart.renderer.path([])
      .attr({
        'stroke': '#f59e0b',
        'stroke-width': 2,
        'stroke-dasharray': '5, 5',
        'zIndex': 5
      })
      .add();

    // Initialize SVG intersection marker (red X)
    this.losMarker = this.chart.renderer.path([])
      .attr({
        'stroke': '#ef4444',
        'stroke-width': 2,
        'zIndex': 6
      })
      .add();

    // Initialize SVG tilt angle label (orange, near midpoint of LOS line)
    this.losAngleLabel = this.chart.renderer.text('', 0, 0)
      .attr({ zIndex: 7, visibility: 'hidden' })
      .css({ color: '#f59e0b', fontSize: '11px', fontWeight: 'bold', textShadow: '1px 1px 3px rgba(0,0,0,0.6)' })
      .add();

    // Initialize map LOS intersection marker
    if (this.map) {
      const mapLosIcon = L.divIcon({
        className: '',
        html: `<div style="position: relative; width: 0; height: 0;">
                 <svg width="12" height="12" viewBox="0 0 12 12" style="position: absolute; left: -6px; top: -6px;">
                   <path d="M2,2 L10,10 M2,10 L10,2" stroke="#ef4444" stroke-width="3" stroke-linecap="round"/>
                 </svg>
               </div>`,
        iconSize: [0, 0]
      });
      this.mapLosMarker = L.marker([0, 0], { 
        icon: mapLosIcon, 
        interactive: false,
        opacity: 0
      }).addTo(this.map);
    }
  }

  private drawElevationProfileLine(): void {
    if (!this.elevationProfile || !this.map) {
      return;
    }

    // Remove existing profile lines/group if present
    if (this.elevationProfileLine) {
      this.map.removeLayer(this.elevationProfileLine);
      this.elevationProfileLine = null;
    }
    if (this.elevationProfileHitLine) {
      this.map.removeLayer(this.elevationProfileHitLine);
      this.elevationProfileHitLine = null;
    }
    if (this.elevationProfileGroup) {
      this.map.removeLayer(this.elevationProfileGroup);
      this.elevationProfileGroup = null;
    }

    // Create lat/lng array from elevation profile points
    const latlngs: L.LatLngExpression[] = this.elevationProfile.points.map(pt => [pt.lat, pt.lng]);

    // Create feature group to hold all colored segments
    this.elevationProfileGroup = L.featureGroup().addTo(this.map);

    // Draw segmented polylines based on visibility
    let currentSegment: L.LatLngExpression[] = [latlngs[0]];
    let currentVis = this.elevationProfile.points[0].visible ?? true;

    for (let i = 1; i < this.elevationProfile.points.length; i++) {
      currentSegment.push(latlngs[i]);
      const pointVis = this.elevationProfile.points[i].visible ?? true;

      // If visibility state changes, or we reach the end, draw the accumulated segment
      if (pointVis !== currentVis || i === this.elevationProfile.points.length - 1) {
        L.polyline(currentSegment, {
          color: currentVis ? '#22c55e' : '#9ca3af', // Green (Visible) or Gray (Obscured)
          weight: 4,
          opacity: 0.9,
          lineCap: 'round',
          lineJoin: 'round',
          interactive: false
        }).addTo(this.elevationProfileGroup);

        // Seed the next segment with the intersecting point to prevent visual gaps
        currentSegment = [latlngs[i]];
        currentVis = pointVis;
      }
    }

    // Draw invisible wider hit line for easier hover detection
    this.elevationProfileHitLine = L.polyline(latlngs, {
      weight: 25, // Much wider for easier hover
      opacity: 0, // Invisible
      interactive: true
    }).addTo(this.map);

    // Add mouse move event to the hit line (wider invisible line)
    this.elevationProfileHitLine.on('mousemove', (e: L.LeafletMouseEvent) => {
      if (!this.chart || !this.elevationProfile) {
        return;
      }

      // Find the closest point in the elevation profile to the mouse position
      let minDistanceSq = Infinity;
      let closestIndex = 0;
      
      const mouseLat = e.latlng.lat;
      const mouseLng = e.latlng.lng;
      const cosLat = Math.cos(mouseLat * Math.PI / 180);

      for (let i = 0; i < this.elevationProfile.points.length; i++) {
        const dLat = this.elevationProfile.points[i].lat - mouseLat;
        const dLng = (this.elevationProfile.points[i].lng - mouseLng) * cosLat;
        const distSq = dLat * dLat + dLng * dLng;
        
        if (distSq < minDistanceSq) {
          minDistanceSq = distSq;
          closestIndex = i;
        }
      }

      // Update the chart to highlight the corresponding point
      const chartPoint = this.chart.series[0].points[closestIndex];
      if (chartPoint) {
        if ((this.chart as any).hoverPoint && (this.chart as any).hoverPoint !== chartPoint) {
          (this.chart as any).hoverPoint.setState('');
        }
        chartPoint.setState('hover');
        this.chart.tooltip.refresh(chartPoint);
        this.chart.xAxis[0].drawCrosshair(null, chartPoint);
      }

      // Also update the hover marker on the map
      const closestPt = this.elevationProfile.points[closestIndex];
      if (this.elevationHoverMarker) {
        this.elevationHoverMarker.setLatLng([closestPt.lat, closestPt.lng]);
        this.elevationHoverMarker.setStyle({ opacity: 1, fillOpacity: 1 });
      }

      // Update line-of-sight visualization
      this.updateLosLine(closestIndex);
    });

    // Hide chart crosshair and marker when mouse leaves the hit line
    this.elevationProfileHitLine.on('mouseout', () => {
      if (this.chart) {
        this.chart.tooltip.hide();
        this.chart.xAxis[0].hideCrosshair();
        if ((this.chart as any).hoverPoint) {
          (this.chart as any).hoverPoint.setState('');
        }
      }
      if (this.elevationHoverMarker) {
        this.elevationHoverMarker.setStyle({ opacity: 0, fillOpacity: 0 });
      }
      // Hide line-of-sight visualization
      this.updateLosLine(null);
    });

    // Ensure hover marker is always on top of the polylines
    if (this.elevationHoverMarker) {
      this.elevationHoverMarker.bringToFront();
    }
  }

  /**
   * Update line-of-sight visualization on hover
   * Renders orange dashed line from observer to target and red X at terrain intersection
   */
  private updateLosLine(targetIndex: number | null): void {
    if (!this.chart || !this.elevationProfile || !this.losLine || !this.losMarker) {
      return;
    }

    if (targetIndex === null || targetIndex === undefined || targetIndex < 0) {
      // Hide visualizations
      this.losLine.attr({ d: [] });
      this.losMarker.attr({ d: [] });
      if (this.losAngleLabel) { this.losAngleLabel.attr({ visibility: 'hidden' }); }
      if (this.mapLosMarker) {
        this.mapLosMarker.setOpacity(0);
      }
      return;
    }
    
    const targetPt = this.elevationProfile.points[targetIndex];
    const startX = this.chart.xAxis[0].toPixels(0);
    const startY = this.chart.yAxis[0].toPixels(this.observerElevation);
    const endX = this.chart.xAxis[0].toPixels(targetPt.distance);
    const endY = this.chart.yAxis[0].toPixels(targetPt.elevation);
    
    // Draw line-of-sight line from observer to target
    this.losLine.attr({
      d: ['M', startX, startY, 'L', endX, endY]
    });

    // Calculate and display tilt angle
    if (this.losAngleLabel) {
      if (targetIndex > 0 && targetPt.distance > 0) {
        const tiltRad = Math.atan2(targetPt.elevation - this.observerElevation, targetPt.distance * 1000);
        const tiltDeg = tiltRad * (180 / Math.PI);
        const sign = tiltDeg >= 0 ? '+' : '';
        const midX = (startX + endX) / 2;
        const midY = Math.min(startY, endY) - 14;
        this.losAngleLabel.attr({
          text: `${sign}${tiltDeg.toFixed(2)}°`,
          x: midX,
          y: midY,
          visibility: 'visible'
        });
      } else {
        this.losAngleLabel.attr({ visibility: 'hidden' });
      }
    }

    // Calculate the first intersection point of the LOS line with the terrain
    let intersectX: number | null = null;
    let intersectY: number | null = null;
    let intersectLat: number | null = null;
    let intersectLng: number | null = null;
    
    if (targetPt.distance > 0) {
      const m_los = (targetPt.elevation - this.observerElevation) / targetPt.distance;
      
      // Check every segment leading up to the hovered point
      for (let i = 1; i < targetIndex; i++) {
        const x1 = this.elevationProfile.points[i-1].distance;
        const y1 = this.elevationProfile.points[i-1].elevation;
        const x2 = this.elevationProfile.points[i].distance;
        const y2 = this.elevationProfile.points[i].elevation;
        
        const yLine1 = m_los * x1 + this.observerElevation;
        const yLine2 = m_los * x2 + this.observerElevation;
        
        // Does the terrain segment cross the line of sight?
        if (y1 <= yLine1 && y2 >= yLine2) {
          // Snap to the data point blocking the view
          intersectX = x2;
          intersectY = y2;
          intersectLat = this.elevationProfile.points[i].lat;
          intersectLng = this.elevationProfile.points[i].lng;
          break; // Stop at the first intersection
        }
      }
    }

    // Draw the 'X' marker on the chart and map if an intersection occurred
    if (intersectX !== null && intersectY !== null && intersectLat !== null && intersectLng !== null) {
      const px = this.chart.xAxis[0].toPixels(intersectX);
      const py = this.chart.yAxis[0].toPixels(intersectY);
      const s = 5; // Half-size of the X
      this.losMarker.attr({
        d: ['M', px - s, py - s, 'L', px + s, py + s, 'M', px - s, py + s, 'L', px + s, py - s]
      });
      
      if (this.mapLosMarker) {
        this.mapLosMarker.setLatLng([intersectLat, intersectLng]);
        this.mapLosMarker.setOpacity(1);
      }
    } else {
      this.losMarker.attr({ d: [] });
      if (this.mapLosMarker) {
        this.mapLosMarker.setOpacity(0);
      }
    }
  }

  lastSitesGroup: L.featureGroup;
  private normalizeLatitude(latitude: number): number {
    if (latitude == null || isNaN(latitude as any)) {
      return null;
    }

    if (latitude < -90 || latitude > 90) {
      return null;
    }

    return latitude;
  }

  private normalizeLongitude(longitude: number): number {
    if (longitude == null || isNaN(longitude as any)) {
      return null;
    }

    // Normalize to the conventional -180..180 range so wrapped values still render.
    return ((((longitude + 180) % 360) + 360) % 360) - 180;
  }

  public displaySites(sites: SiteTwin[], getIcon, onSiteRendered, onSelectSite, clearPrevious){
    if (this.map == null) return;

    if (clearPrevious && this.lastSitesGroup){
      this.map.removeLayer(this.lastSitesGroup);
    }

    var markers = [];
    var layers = [];
    for (let site of sites){
      try {
        const normalizedLatitude = this.normalizeLatitude(site.latitude);
        const normalizedLongitude = this.normalizeLongitude(site.longitude);
        if (normalizedLatitude != null && normalizedLongitude != null && this.map){
          site.latitude = normalizedLatitude;
          site.longitude = normalizedLongitude;
          //const icon = getIcon(site.siteType)
          //const icon = {icon:this.pins[site.siteType] ?? this.defaultIcon};
          const icon = getIcon(site, this.icons.pins) ?? this.defaultIcon;
          //marker = L.marker([data.latitude, data.longitude],{icon:pin, title:data.name}).addTo(this.map);
          const marker = L.marker([normalizedLatitude, normalizedLongitude], icon)
          
          // Add tooltip with site name and description
          let tooltipContent = '<div>' + (site.siteName || 'Unknown Site');
          if (site.siteDescription) {
            tooltipContent += '<br>' + site.siteDescription;
          }
          tooltipContent += '</div>';
          marker.bindTooltip(tooltipContent, {
            direction: 'top',
            offset: [0, -20]
          });
          
          try{
            marker.addTo(this.map);
          } catch(ex){
            // assuming error related to bouncing markers and windbarbs
          }
          if (onSelectSite) {
            marker.on('click', () => onSelectSite(marker, site));      
          }
          if (onSiteRendered){
            var items = onSiteRendered(site);
            if (items){
              for (let item of items){
                //layers.push(layer);
                item.addTo(this.map);
              }
              layers = layers.concat(items);
            }
          }
          markers.push(marker);
        }
      } catch(ex){
        console.error("Error displaying site:", ex);
      }
    }
    var features = [];
    features = features.concat(markers);
    //features = features.concat(layers);
    var group = L.featureGroup(features).addTo(this.map);
    this.groups = layers;
    //var dataGroup : L.featureGroup = L.featureGroup();
    //dataGroup.addLayer(group);
    try{
      this.map.fitBounds(group.getBounds(), {maxZoom:13});
    } catch(ex){
    }
    this.lastSitesGroup = group;
    return group;
  }

  bearing: any;
  public displayBearing(site: SiteTwin, bearing: number, viewangle: number, distanceMeters?: number){
    if (this.map == null) return;

    if (this.bearing != null){
      this.map.removeLayer(this.bearing);
    }
    var arc = viewangle / 2;
    var radius = distanceMeters || 30000; // Default to 30km if not provided
    var semicirc = L.semiCircle([site.latitude, site.longitude], {
      radius: radius,
      startAngle: bearing - (arc),
      stopAngle: bearing + (arc),
      fillOpacity: 0.1,
      weight:0
    });
    this.bearing = L.featureGroup([semicirc]);
    this.bearing.addTo(this.map);
    
    // Update elevation chart if bearing matches profile
    if (this.chart && this.elevationProfile && Math.abs(this.elevationProfile.bearing - bearing) < 1) {
      // Find the closest point at the given distance (if provided)
      if (distanceMeters) {
        const distanceKm = distanceMeters / 1000;
        this.updateElevationChartCrosshair(distanceKm);
      }
    }
  }
  
  public updateElevationChartCrosshair(distanceKm: number): void {
    if (!this.chart || !this.elevationProfile) {
      return;
    }
    
    // Find the closest point in the elevation profile
    let closestIndex = 0;
    let minDiff = Math.abs(this.elevationProfile.points[0].distance - distanceKm);
    
    for (let i = 1; i < this.elevationProfile.points.length; i++) {
      const diff = Math.abs(this.elevationProfile.points[i].distance - distanceKm);
      if (diff < minDiff) {
        minDiff = diff;
        closestIndex = i;
      }
    }
    
    // Update chart visualization
    const chartPoint = this.chart.series[0].points[closestIndex];
    if (chartPoint) {
      if ((this.chart as any).hoverPoint && (this.chart as any).hoverPoint !== chartPoint) {
        (this.chart as any).hoverPoint.setState('');
      }
      chartPoint.setState('hover');
      this.chart.tooltip.refresh(chartPoint);
      this.chart.xAxis[0].drawCrosshair(null, chartPoint);
    }
  }

  detection: { [id: number] : L.semiCircle; } = {};
  public hideDetections(){
    for (let incidentId of Object.keys(this.detection)){
      this.map.removeLayer(this.detection[incidentId]);
    }
  }
  public hideDetection(incidentId: number){
    if (this.detection != null && this.detection[incidentId] != null){
      this.map.removeLayer(this.detection[incidentId]);
    }
  }
  public displayDetection(incidentId: number, site: Camera, bearing: number, viewangle: number, distanceMeters?: number){
    if (this.map == null) return;

    if (this.detection != null && this.detection[incidentId] != null){
      this.map.removeLayer(this.detection[incidentId]);
    }
    var arc = viewangle / 2;
    var radius = distanceMeters || 30000; // Default to 30km if not provided
    var semicirc = L.semiCircle([site.latitude, site.longitude], {
      radius: radius,
      startAngle: bearing - (arc),
      stopAngle: bearing + (arc),
      color: '#F00',
      fillColor: '#F00',
      weight: 1
    });
    this.detection[incidentId] = L.featureGroup([semicirc]);
    this.detection[incidentId].addTo(this.map);
    //this.map.add(this.bearing)
  }

  arc: any;
  public displayArc(site: SiteTwin, bearing: number, viewangle: number, distanceMeters?: number){
    if (this.map == null) return;

    if (this.arc != null){
      this.map.removeLayer(this.arc);
    }
    var arc = viewangle / 2;
    var radius = distanceMeters || 30000; // Default to 30km if not provided
    var semicirc = L.semiCircle([site.latitude, site.longitude], {
      radius: radius,
      startAngle: bearing - (arc),
      stopAngle: bearing + (arc),
      color: '#00F',
      fillColor: '#00F',
      weight: 1
    });
    this.arc = L.featureGroup([semicirc]);
    this.arc.addTo(this.map);
    //this.map.add(this.bearing)
  }

  direction: any;
  public displayDirection(site: SiteTwin, bearing: number){
    if (this.direction != null){
      this.map.removeLayer(this.direction);
    }
    var arc = 0.1;
    var semicirc = L.semiCircle([site.latitude, site.longitude], {
      radius: 30000,
      startAngle: bearing - (arc),
      stopAngle: bearing + (arc),
      color: '#F00',
      fillColor: '#F00',
      weight: 1
    });
    this.direction = L.featureGroup([semicirc]);
    this.direction.addTo(this.map);
    //this.map.add(this.bearing)
  }

  public setZoom(zoom){
    this.map.setZoom(zoom);
  }

  public removeLayer(layer){
    this.map.removeLayer(layer);
  }

  public showLayer(layer){
    this.map.addLayer(layer);
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private buildFeaturePopupContent(properties: any): string {
    if (!properties || typeof properties !== 'object') {
      return '';
    }
    const keysToSkip = ['style'];
    const contentLines = Object.entries(properties)
      .filter(([key, value]) => value !== null && value !== undefined && !keysToSkip.includes(key))
      .map(([key, value]) => {
        const displayValue = (typeof value === 'object' && !Array.isArray(value)) ? '[Object]' : value;
        return `<b>${key}</b>: ${displayValue}`;
      });
    return contentLines.join('<br>');
  }

  private parseLayerStyleOptions(styles: string): any {
    if (!styles) {
      return null;
    }

    try {
      const parsed = JSON.parse(styles);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (error) {
      console.warn('Layer styles are not valid JSON', error);
      return null;
    }
  }

  private pixelValue(pointValue: number): number {
    return pointValue * 1.333;
  }

  private esriColorValue(color: number[]): string {
    return `rgb(${color[0]},${color[1]},${color[2]})`;
  }

  private esriAlphaValue(color: number[]): number {
    return color[3] / 255.0;
  }

  private resolveConfiguredLayerIcon(styleOptions: any): any {
    if (!styleOptions) {
      return null;
    }

    const pinId = Number(styleOptions.mapPinId ?? styleOptions.pinId ?? styleOptions.mapPinID ?? styleOptions.pinID);
    if (!Number.isNaN(pinId) && this.icons.pinsById && this.icons.pinsById[pinId]) {
      return this.icons.pinsById[pinId];
    }

    const pinName = styleOptions.pinName ?? styleOptions.mapPinName ?? styleOptions.iconName;
    if (pinName && this.icons.pins && this.icons.pins[pinName]) {
      return this.icons.pins[pinName];
    }

    if (styleOptions.iconUrl) {
      return L.icon({
        iconRetinaUrl: styleOptions.iconRetinaUrl,
        iconUrl: styleOptions.iconUrl,
        shadowUrl: styleOptions.shadowUrl,
        iconSize: styleOptions.iconSize,
        iconAnchor: styleOptions.iconAnchor,
        popupAnchor: styleOptions.popupAnchor,
        tooltipAnchor: styleOptions.tooltipAnchor,
        shadowSize: styleOptions.shadowSize
      });
    }

    return null;
  }

  private resolveEsriPointSymbol(feature: any, drawingInfo: any): any {
    const renderer = drawingInfo?.renderer;
    if (!renderer) {
      return null;
    }

    if (renderer.type === 'uniqueValue') {
      const delimiter = renderer.fieldDelimiter ?? ',';
      let value = feature.properties?.[renderer.field1];
      if (renderer.field2 && feature.properties?.[renderer.field2] != null) {
        value += delimiter + feature.properties[renderer.field2];
      }
      if (renderer.field3 && feature.properties?.[renderer.field3] != null) {
        value += delimiter + feature.properties[renderer.field3];
      }

      const match = renderer.uniqueValueInfos?.find((info: any) => info.value == value);
      return match?.symbol ?? renderer.defaultSymbol ?? null;
    }

    if (renderer.type === 'classBreaks') {
      const value = Number(feature.properties?.[renderer.field]);
      const match = renderer.classBreakInfos?.find((info: any) => value >= info.classMinValue && value <= info.classMaxValue);
      return match?.symbol ?? renderer.defaultSymbol ?? null;
    }

    return renderer.symbol ?? renderer.defaultSymbol ?? null;
  }

  private resolveEsriPictureMarkerIcon(symbol: any, esriUrl: string): any {
    if (!symbol || symbol.type !== 'esriPMS') {
      return null;
    }

    let resolvedIconUrl = symbol.url;
    if (symbol.imageData) {
      resolvedIconUrl = `data:${symbol.contentType};base64,${symbol.imageData}`;
    } else if (resolvedIconUrl && !/^https?:\/\//i.test(resolvedIconUrl)) {
      resolvedIconUrl = `${esriUrl.replace(/\/$/, '')}/images/${resolvedIconUrl}`;
    }

    if (!resolvedIconUrl) {
      return null;
    }

    const width = this.pixelValue(symbol.width ?? symbol.size ?? 25);
    const height = this.pixelValue(symbol.height ?? symbol.width ?? symbol.size ?? 25);
    const xOffset = (width / 2) + this.pixelValue(symbol.xoffset ?? 0);
    const yOffset = (height / 2) + this.pixelValue(symbol.yoffset ?? 0);

    return L.icon({
      iconUrl: resolvedIconUrl,
      iconSize: [width, height],
      iconAnchor: [xOffset, yOffset]
    });
  }

  private resolveEsriSimpleMarkerStyle(symbol: any): any {
    if (!symbol || symbol.type !== 'esriSMS') {
      return null;
    }

    const style: any = {
      radius: this.pixelValue(symbol.size ?? 10) / 2,
      fillOpacity: 0,
      stroke: false
    };

    if (symbol.color) {
      style.fillColor = this.esriColorValue(symbol.color);
      style.fillOpacity = this.esriAlphaValue(symbol.color);
    }

    if (symbol.outline && symbol.outline.style !== 'esriSLSNull') {
      style.stroke = true;
      style.weight = this.pixelValue(symbol.outline.width ?? 1);
      style.color = this.esriColorValue(symbol.outline.color);
      style.opacity = this.esriAlphaValue(symbol.outline.color);
    }

    return style;
  }

  private resolveEsriMarkerIcon(feature: any, drawingInfo: any, esriUrl: string, styleOptions: any): any {
    return this.resolveConfiguredLayerIcon(styleOptions)
      || this.resolveEsriPictureMarkerIcon(this.resolveEsriPointSymbol(feature, drawingInfo), esriUrl)
      || this.defaultIcon
      || iconDefault;
  }

  private createEsriPointLayer(feature: any, latlng: L.LatLng, drawingInfo: any, esriUrl: string, styleOptions: any): L.Layer {
    const configuredIcon = this.resolveConfiguredLayerIcon(styleOptions);
    if (configuredIcon) {
      return L.marker(latlng, { icon: configuredIcon });
    }

    const symbol = this.resolveEsriPointSymbol(feature, drawingInfo);
    const pictureIcon = this.resolveEsriPictureMarkerIcon(symbol, esriUrl);
    if (pictureIcon) {
      return L.marker(latlng, { icon: pictureIcon });
    }

    const simpleMarkerStyle = this.resolveEsriSimpleMarkerStyle(symbol);
    if (simpleMarkerStyle) {
      return L.circleMarker(latlng, simpleMarkerStyle);
    }

    return L.marker(latlng, { icon: this.defaultIcon || iconDefault });
  }

  public loadLinkLayerContent(type: string, layerId: number, json: any, layerName: string, styles: string, tileSize: number, useProxy: boolean, onClick){
    console.log("Layer Added " + layerId, layerName);
    if (type == "wms"){
      var url = json;
      if (useProxy){
        url = "/api/Map/Proxy/" + layerId;
      }

      if (tileSize < 256) {
        tileSize = 256;
      }
      if (tileSize > 2048) {
        tileSize = 2048;
      }
      
      var wmsLayer = L.tileLayer.wms(url, {
        layers: layerName, 
        transparent:true,
        crossOrigin: false,
        styles:styles == null ? '': styles,
        tileSize: tileSize,
        //token:'basic Ym9tdzA3OTM6bUFtYTY2dEo=',
        format:'image/png'}).addTo(this.map);
        

      return wmsLayer;
    } 
    else if (type == "kml") {
      //todo: download the KML and pass it in
      var kml = KML.layer(json);
      //const markerGroup = L.markerClusterGroup();
      //markerGroup.addLayer(kml);
      kml.addTo(this.map);
      return kml;
    }
    else if (type == "kmz") {
      //todo: download the KML and pass it in
      var kml = KML.layerFromKMZ(json);
      //const markerGroup = L.markerClusterGroup();
      //markerGroup.addLayer(kml);
      kml.addTo(this.map);
      return kml;
    }
    else if (type == "geojson") {
      var styleObj = {};
      if (styles != null && styles != ''){
        styleObj = JSON.parse(styles)
      }
      var datalayer = L.geoJson(json, 
        {
          pointToLayer: function (feature, latlng) {
            if (feature && feature.properties && feature.properties.type && feature.properties.type.eventIcon){
              //var popup = feature.properties.bodyHtml;
              //featureLayer.bindPopup(popup);
              
              //console.log(feature.properties.type);
              var type = feature.properties.alertLevel;
              var icon = feature.properties.type.eventIcon;
              var iconUrl = '/assets/icons/' + icon + ".svg";
              if (type == "emergency_warning"){
                var iconUrl = '/assets/icons/' + icon + "_red.svg";
              }
              if (type == "watch_and_act"){
                var iconUrl = '/assets/icons/' + icon + "_orange.svg";
              }
              if (type == "advice"){
                var iconUrl = '/assets/icons/' + icon + "_yellow.svg";
              }

                /*if (feature.properties.burntAreaGeometry){
  
                }*/

              var marker = L.marker(latlng, {icon:L.icon({iconUrl:iconUrl,iconSize:[38, 95]})});
              marker.on('click', () => onClick(feature));
              return marker;
            }
            else if (feature && feature.properties && feature.properties.style) {
              var style = feature.properties.style;
              return L.circleMarker(latlng, {
                radius: 8,
                fillOpacity: 0.85,
                weight: 1, // border weight
                ...style // Apply the dynamic color and fillColor
              });
            }
          },
          onEachFeature: function (feature, layer) {
            const props = feature.properties;

            // Check if properties exist before processing
            if (!props || typeof props !== 'object') {
              return;
            }

            // --- SOLUTION ---
            // Define a "blacklist" of keys you always want to ignore
            const keysToSkip = ['style']; 
            // You could easily add more, e.g.: ['style', 'id', 'internal_ref']
            // ---

            const contentLines = Object.entries(props)
                .filter(([key, value]) => {
                    // Conditions to KEEP an item:
                    // 1. Value is not null/undefined
                    // 2. The key is NOT in our 'keysToSkip' array
                    return value !== null && 
                           value !== undefined && 
                           !keysToSkip.includes(key); // <-- Checks the array
                })
                .map(([key, value]) => {
                    let displayValue = value;

                    // Handle values that are objects (but not arrays)
                    if (typeof value === 'object' && !Array.isArray(value)) {
                        displayValue = '[Object]'; 
                    }
                    
                    // Simple formatting: Bold the key
                    return `<b>${key}</b>: ${displayValue}`;
                });
            
            const tooltipContent = contentLines.join('<br>');
            if (tooltipContent != '<br>'){layer.bindTooltip(tooltipContent);}
            
          },
          
          style:styleObj
        }).addTo(this.map);
      return datalayer;
    } 
    else if (type == "esri"){
      // A FeatureServer/MapServer root URL (no trailing /<sublayer id>) returns the service
      // catalog (a `layers` list) instead of a single layer's schema. esri-leaflet expects
      // fields/geometryType on that response and throws "Cannot read properties of undefined"
      // when they're missing, with no useful message about why.
      var esriUrl: string = json;
      if (!/\/\d+\/?$/.test(esriUrl)) {
        console.error(`[ESRI ${layerName}] URL "${esriUrl}" looks like a service root, not a single layer. ` +
          `Append the sublayer id, e.g. ${esriUrl.replace(/\/$/, '')}/0. Defaulting to /0 for now.`);
        esriUrl = esriUrl.replace(/\/$/, '') + '/0';
      }

      // EL.featureLayer() re-queries per map-viewport tile (resultType=tile/quantized geometry).
      // Some third-party ArcGIS-compatible backends (like this one) 500 on those params, so
      // fetch the data with a single plain query instead and render it as static GeoJSON.
      var styleOptions = this.parseLayerStyleOptions(styles);
      var drawingInfo: any = null;
      var datalayer = L.geoJson(null, {
        pointToLayer: (feature: any, latlng: L.LatLng) => this.createEsriPointLayer(feature, latlng, drawingInfo, esriUrl, styleOptions),
        onEachFeature: (feature: any, layer: L.Layer) => {
          layer.on('click', (e: L.LeafletMouseEvent) => {
            (layer as any).bindPopup(this.buildFeaturePopupContent(feature.properties), { maxWidth: 300 }).openPopup(e.latlng);
            if (onClick) {
              onClick(feature);
            }
          });

          // Line/polygon geometry (e.g. an incident's detection path) has no visible marker by
          // default, so drop a pin on its last point to make the incident easy to spot/click.
          const geomType = feature.geometry?.type;
          if (geomType === 'LineString' || geomType === 'MultiLineString') {
            const lines = geomType === 'LineString' ? [feature.geometry.coordinates] : feature.geometry.coordinates;
            const lastLine = lines[lines.length - 1];
            const [lng, lat] = lastLine[lastLine.length - 1];
            const marker = L.marker([lat, lng], {
              icon: this.resolveEsriMarkerIcon(feature, drawingInfo, esriUrl, styleOptions)
            });
            marker.on('click', () => {
              marker.bindPopup(this.buildFeaturePopupContent(feature.properties), { maxWidth: 300 }).openPopup();
              if (onClick) {
                onClick(feature);
              }
            });
            datalayer.addLayer(marker);
          }
        }
      }).addTo(this.map);

      const loadFeatures = () => {
        EL.query({ url: esriUrl }).where('1=1').run((error: any, featureCollection: any) => {
          if (error) {
            console.error(`[ESRI ${layerName}] query failed`, error);
            return;
          }
          console.log(`[ESRI ${layerName}] loaded ${featureCollection?.features?.length ?? 0} feature(s)`);
          datalayer.addData(featureCollection);
        });
      };

      (EL as any).request(esriUrl, { f: 'json' }, (metadataError: any, metadata: any) => {
        if (metadataError) {
          console.warn(`[ESRI ${layerName}] metadata request failed; using configured/default marker`, metadataError);
          loadFeatures();
          return;
        }
        drawingInfo = metadata?.drawingInfo ?? null;
        loadFeatures();
      });

      return datalayer;
    } 
    else if (type == "cap"){
      var datalayer = L.geoJson(json, {
        pointToLayer: function (feature, latlng) {
          if (feature && feature.properties){
            //var popup = feature.properties.bodyHtml;
            //featureLayer.bindPopup(popup);
            
            //console.log(feature.properties.type);
            var type = feature.properties.alertLevel;
            var icon = feature.properties.type.eventIcon;
            var iconUrl = '/assets/icons/' + icon + ".svg";
            if (type == "emergency_warning"){
              var iconUrl = '/assets/icons/' + icon + "_red.svg";
            }
            if (type == "watch_and_act"){
              var iconUrl = '/assets/icons/' + icon + "_orange.svg";
            }
            if (type == "advice"){
              var iconUrl = '/assets/icons/' + icon + "_yellow.svg";
            }

            /*if (feature.properties.burntAreaGeometry){

            }*/

            var marker = L.marker(latlng, {icon:L.icon({iconUrl:iconUrl,iconSize:[38, 95]})});
            marker.on('click', () => onClick(feature));
            return marker;
          }
        }}).addTo(this.map);
      return datalayer;
    } else if (type =="tilemap")
    {
      const tilemap = L.tileLayer(json,{maxZoom: 20});
      tilemap.addTo(this.map);
      return tilemap;
    }
    else if (type == "waemergency")
    {
      //console.log("json",json);
      if(json && json.incidents)
      {
        console.log("loading incidents json");
        const geojson = this.convertToGeoJSON(json.incidents);

        var datalayer = L.geoJson(geojson, 
        {
          pointToLayer: function (feature,latlng) {
            let iconName: string | undefined;
            const defaultIconPath = 'assets/icons/fire.svg'; // Default Icon
            iconName = feature.properties?.['incident-icon'];

            const iconUrl = iconName ? `assets/icons/waemergency/${iconName}.svg` : defaultIconPath;
            console.log("icon",iconUrl);
            var marker = L.marker(latlng, {icon:L.icon({iconUrl:iconUrl,iconSize:[38, 95]})});
            marker.on('click', () => onClick(feature));
            return marker;
          },
          style:styleObj
        }).addTo(this.map);
        return datalayer;
      }
      else if (json && json.warnings)
    {
        console.log("loading warnings json");
        const geojson = this.convertToGeoJSON(json.warnings);

        var datalayer = L.geoJson(geojson, 
        {
          pointToLayer: function (feature,latlng) {
            let iconName: string | undefined;
            const defaultIconPath = 'assets/icons/fire.svg'; // Default Icon
            iconName = feature.properties?.['geo-source']?.features?.[0]?.properties?.['icon-name'];

            const iconUrl = iconName ? `assets/icons/waemergency/${iconName}.svg` : defaultIconPath;
            console.log("icon",iconUrl);
            var marker = L.marker(latlng, {icon:L.icon({iconUrl:iconUrl,iconSize:[38, 95]})});
            marker.on('click', () => onClick(feature));
            return marker;
          },
          style:styleObj
        }).addTo(this.map);
        return datalayer;
    }
    }
    else if (type == "waemergency-dat")
    {
      console.log("dat file");
      //const ab = this.base64ToArrayBuffer(json as string);
      //const ab = this.binaryStringToArrayBuffer(json as string);
      // const textEncoder = new TextEncoder();
      // const utf8Bytes = textEncoder.encode(json);
      // const ab = utf8Bytes.buffer;
      // const data = decode(ab);
      
      // console.log("decoded",data);
      let data;
      this.http.get(json,{responseType: 'arraybuffer'}).subscribe(resp=>{
        console.log('response is: ',resp);
        data = decode(resp);
        console.log("data is: ", data);
      })
    }
    
    else {
      console.error("Unsupported Layer Type: " + type);
    }
  }

  locations: { [id: string] : L.marker; } = {};
  public showIncidentLocation(location:Location, icon: any, onClick: any, popupContent?: string){
    if (location && location.latitude && location.longitude && this.map){
      if (this.locations[location.identifier] == null){
        const pointMarker = L.marker([location.latitude,location.longitude],{icon:icon}).addTo(this.map);
        this.locations[location.identifier] = pointMarker;
        
        if (popupContent) {
          pointMarker.bindPopup(popupContent, {
            maxWidth: 300,
            className: 'incident-popup'
          });
        }
        
        pointMarker.on('click', () => {
          if (onClick) {
            onClick(location);
          }
        });
      }
    }
  }  

  public removeIncidentLocation(identifier){
    var marker = this.locations[identifier];
    if (marker){
      marker.remove(this.map);
      delete this.locations[identifier];
    }
  }

  public removeIncidentLocations(){
    for (let incidentId of Object.keys(this.locations)){
      this.removeIncidentLocation(incidentId);
    }
    //this.location = null;
    //this.pointMarker = null;
  }
  
  pointMarker: L.marker;
  icon: any
  // Keeps the active incident pin above all other site/incident pins regardless of add order, so it stays draggable.
  private readonly activeIncidentZIndexOffset = 10000;
  
  public showActiveIncidentLocation(location:Location, icon: any){
    if (this.pointMarker){
      this.pointMarker.remove(this.map);
    }
    this.location = location;
    this.icon = icon;
    if (this.icon == null){
      this.icon = this.defaultIcon;
    }
    if (this.location && this.location.latitude && this.location.longitude && this.map){
      //if (this.locations[location.identifier] == null){
        this.pointMarker = L.marker([this.location.latitude,this.location.longitude],{icon:this.icon, zIndexOffset:this.activeIncidentZIndexOffset}).addTo(this.map);
        //this.locations[location.identifier] = this.pointMarker;
        this.pointMarker.on('dragend', event => {
          console.log("Location Move Complete");
          var marker = event.target;
          var position = marker.getLatLng();
          marker.setLatLng(new L.LatLng(position.lat, position.lng),{draggable:'true'});
          this.location.latitude = position.lat;
          this.location.longitude = position.lng;
        });      
      //}
    }
  }  

  public removeActiveIncidentLocation(){
    var marker = this.pointMarker;//this.locations[identifier];
    if (marker){
      marker.remove(this.map);
      //this.locations[identifier] = null;
      //delete this.locations[identifier];
      this.location = null;
      this.pointMarker = null;
    }
  }


  public enableLocationSelect(icon: any){
    this.icon = icon;
    if (this.icon == null){
      this.icon = this.defaultIcon;
    }
    if (this.pointMarker) {
      this.pointMarker.dragging?.enable();
    }
    this.map.on('click', e => { 
      if (this.pointMarker) {
        this.pointMarker.on('dragend', event => {
          console.log("Location Move Complete");
          var marker = event.target;
          var position = marker.getLatLng();
          marker.setLatLng(new L.LatLng(position.lat, position.lng),{draggable:'true'});
          this.location.latitude = position.lat;
          this.location.longitude = position.lng;
        });
      } else {
        this.location.latitude = e.latlng.lat;
        this.location.longitude = e.latlng.lng;
        if (this.pointMarker){
          this.pointMarker.setLatLng(e.latlng);
          this.location.latitude = e.latlng.lat;
          this.location.longitude = e.latlng.lon;
        }else{
          this.pointMarker = L.marker([this.location.latitude,this.location.longitude],{icon:this.icon, draggable:'true', zIndexOffset:this.activeIncidentZIndexOffset}).addTo(this.map);
    
          this.pointMarker.on('dragend', event => {
            var marker = event.target;
            var position = marker.getLatLng();
            marker.setLatLng(new L.LatLng(position.lat, position.lng),{draggable:'true'});
            this.location.latitude = position.lat;
            this.location.longitude = position.lng;
          });
        }
      }
    });
  }

  public disableLocationSelect(location:Location = null){
    if(this.pointMarker)
    {
      if(location != null)
      {
        this.location = location;
        
        this.pointMarker.setLatLng(new L.LatLng(location.latitude, location.longitude),{draggable:'false'})
      }
      this.pointMarker.dragging.disable();      
    }
    
  }

  convertToGeoJSON(items: Array<Incident | Warning>): GeoJsonFeatureCollection {
    const features: GeoJsonFeature[] = items.map((item) => {
      let longitude: number | undefined;
      let latitude: number | undefined;

      if (item.location && typeof item.location.latitude === 'number' && typeof item.location.longitude === 'number') {
        longitude = item.location.longitude;
        latitude = item.location.latitude;
      }
      else if (
        item['geo-source'] &&
        item['geo-source'].features &&
        item['geo-source'].features.length > 0 &&
        item['geo-source'].features[0].geometry &&
        item['geo-source'].features[0].geometry.type === 'Point' &&
        item['geo-source'].features[0].geometry.coordinates &&
        item['geo-source'].features[0].geometry.coordinates.length === 2
      ) {
        longitude = item['geo-source'].features[0].geometry.coordinates[0];
        latitude = item['geo-source'].features[0].geometry.coordinates[1];
      }

      const properties: any = { ...item };
      // No need to add a special 'iconNameToUse' if pointToLayer handles logic based on itemType

      if (typeof longitude === 'number' && typeof latitude === 'number') {
        return {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [longitude, latitude],
          },
          properties: properties, // The whole incident or warning object
        };
      }
      return null;
    }).filter(feature => feature !== null) as GeoJsonFeature[];

    return {
      type: 'FeatureCollection',
      features: features,
    };
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    const binaryString = window.atob(base64); // Decode Base64 to a binary string
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  binaryStringToArrayBuffer(binaryStr: string): ArrayBuffer {
  const len = binaryStr.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    const charCode = binaryStr.charCodeAt(i);
    if (charCode > 255) {
      // This indicates the string is not a simple binary string
      // or has been corrupted. Handle appropriately.
      console.warn(`Character code ${charCode} at index ${i} is out of byte range (0-255).`);
      // You might want to throw an error or handle this case specifically
    }
    bytes[i] = charCode & 0xFF; // Ensure it's a byte
  }
  return bytes.buffer;
}
}

